import { render, staticRenderFns } from "./printpatientconsentform.vue?vue&type=template&id=1249163e"
import script from "./printpatientconsentform.vue?vue&type=script&lang=js"
export * from "./printpatientconsentform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports